import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { ApiSubscriptionStatus, ApiResult, ApiSubscriptionInvoice, ApiPlanList, ApiSubscriptionPeriod, ApiSubscriptionPayment, ApiSubscriptionEstimate, ApiSignalRPostback, ApiResultList } from 'Types'
import { HubConnection } from '@aspnet/signalr'
import uuidv4 from 'uuid/v4'

const endpoint = `${apiUrl.stable}/assinatura`

export const getPlans = (filter: string = ''): ApiResult<ApiPlanList> => {
  const url = `${endpoint}/planos`

  const params = { Filter: filter }

  return axios.get(url, { params })
}

export const getPeriods = (): ApiResult<ApiSubscriptionPeriod[]> => {
  const url = `${endpoint}/periodo`

  return axios.get(url)
}

export const getPlanStatus = (): ApiResult<ApiSubscriptionStatus> => {
  const url = `${endpoint}/corrente`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const requestCancellation = (data): ApiResult<any> => {
  const url = `${endpoint}/cancelamento`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

export const updatePayment = (payId: number, cardId: number = null): ApiResult<any> => {
  const url = `${endpoint}/alterar-forma-de-pagamento`

  const headers = { ...jsonWebToken.header }

  const data = {
    paymentMethod: payId,
    creditCardId: cardId
  }

  return axios.put(url, data, { headers })
}

export const getInvoiceList = (page = 1, pageSize = 10): ApiResultList<ApiSubscriptionInvoice> => {
  const url = `${endpoint}/fatura/lista`

  const headers = { ...jsonWebToken.header }

  const params = {
    Page: page,
    PageSize: pageSize,
  }

  return axios.get(url, { params, headers })
}

export const requestInvoiceBilling = (id, paymentMethod): ApiResult<ApiSubscriptionInvoice> => {
  const url = `${endpoint}/fatura/segunda-via`

  const headers = { ...jsonWebToken.header }

  const params = {
    billId: id,
    paymentMethod
  }

  return axios.post(url, null, { params, headers })
}

export const requestInvoiceBillingTotal = (): ApiResult<ApiSubscriptionInvoice> => {
  const url = `${endpoint}/fatura/segunda-via-tudo-em-aberto`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, null, { headers })
}

export const getEstimate = (connection: string, plan: number = null, period: number = null): ApiResult<ApiSubscriptionEstimate> => {
  const url = `${endpoint}/estimar`

  const headers = { ...jsonWebToken.header }
  const params = { ConnectionId: connection }

  if (plan) {
    params['PlanId'] = plan
  }

  if (period) {
    params['PeriodId'] = period
  }

  return axios.get(url, { params, headers })
}

export const paySubscription = (data: ApiSubscriptionPayment): ApiResult<any> => {
  const url = `${endpoint}/upgrade-com-pagamento`

  const headers = {
    ...jsonWebToken.header,
    'x-requestid': uuidv4()
  }
  return axios.post(url, data, { headers })
}

export const checkPayment = (connection: HubConnection): Promise<void> => {
  const genericErrorMsg = { response: { data: ["Não foi possível efetuar o pagamento com seu cartão de crédito. Por favor tente um outro cartão ou contate sua operadora."] } }

  const checkDev = (resolve, reject) => {
    // setTimeout(() => reject(genericErrorMsg), 3000) USED TO SIMULATE ERROR
    setTimeout(() => resolve(), 3000)
  }

  const checkProd = (resolve, reject) => {
    connection.on('paymentUpdate', (data: ApiSignalRPostback) => data.success
      ? resolve()
      : reject(genericErrorMsg)
    )
  }

  const promiseExecutor = (resolve, reject) => {
    if (process.env.VM_ENV === 'development')
      checkDev(resolve, reject)
    else
      checkProd(resolve, reject)
  }

  return new Promise(promiseExecutor)
}

export const getPendingInvoiceList = () => {
  const url = `${endpoint}/fatura/pendentes`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const postPendingCreditCard = (card) => {
  const url = `${endpoint}/fatura/pendentes`

  const headers = {
    ...jsonWebToken.header,
    'x-requestid': uuidv4()
  }

  return axios.post(url, card, { headers })
}

export const changeInvoiceStatusToOpen = () => {
  const url = `${endpoint}/fatura/reabrir`
  const headers = { ...jsonWebToken.header }

  return axios.post(url, null, { headers })
}

export const retryPayment = (billId: number) => {
  const url = `${endpoint}/fatura/${billId}/cobrar-novamente`
  const headers = { ...jsonWebToken.header }

  return axios.post(url, null, { headers })
}

export const getUrlBoleto = () => {
  const url = `${endpoint}/fatura/boleto`
  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const getDiscount = () => {
  const url = `${endpoint}/360`
  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const getDiscountRange = () => {
  const url = `${endpoint}/360/intervalos-desconto`
  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const getPixInfo = (): ApiResult<ApiSubscriptionStatus> => {
  const url = `${endpoint}/fatura/pix`
  const headers = { ...jsonWebToken.header }
  return axios.get(url, { headers })
}

export const getEligiblePlan = () => {
  const url = `${endpoint}/meu-plano/plano-elegivel`
  const headers = { ...jsonWebToken.header }
  return axios.get(url, { headers })
}

export const getBoletoInfo = (): ApiResult<ApiSubscriptionStatus> => {
  const url = `${endpoint}/fatura/boleto`
  const headers = { ...jsonWebToken.header }
  return axios.get(url, { headers })
}

export const toggleEligiblePlanBanner = (): ApiResult<any> => {
  const url = `${endpoint}/meu-plano/plano-elegivel-notificado`
  const headers = { ...jsonWebToken.header }
  return axios.post(url, null, { headers })
}


export default {
  getPlans,
  getUrlBoleto
}